import FeedLayout from "layouts/files/FeedLayout";
import { Link } from "react-router-dom";
import { ActivityItem, SVG } from "ui";

import { DemoActivityItem } from "ui/files/others/ActivityItem";
import { useState } from "react";
import { ClearActivityModal } from "components";

export type DemoActivityGroup = {
    today: DemoActivityItem[];
    thisWeek: DemoActivityItem[];
    thisMonth: DemoActivityItem[];
    pastDays: DemoActivityItem[];
};

const demoActivityGroup: DemoActivityGroup = {
    today: [
        {
            id: 1,
            title: "Like",
            label: "You liked someones post",
            details: "who wnat's to party",
            date: "2 min ago",
            svg: "heart"
        },
        {
            id: 2,
            title: "Repost",
            label: "you have reposted @someones post",
            details: "Who wins IPL match",
            date: "5 min ago",
            svg: "repeat"
        },
        {
            id: 3,
            title: "Post",
            label: "You have create a post",
            details: "you have created text with #hashtag and @someone",
            date: "3 hr ago",
            svg: "post"
        }
    ],
    thisWeek: [
        {
            id: 4,
            title: "poll - Vote Post",
            label: "You have vote from @someone",
            details: "Who won IPl match",
            date: "5 April 2024",
            svg: "check-square"
        },
        {
            id: 5,
            title: "Post",
            label: "you have created Audio post",
            details: "",
            date: "1 April 2024",
            svg: "post"
        },
        {
            id: 6,
            title: "Post",
            label: "you have created Vido post",
            details: "",
            date: "31 March 2024",
            svg: "post"
        },
        {
            id: 7,
            title: "Post",
            label: "You have created incident",
            details: "Rajkot Location",
            date: "31 March 2024",
            svg: "post",
            isIncident: true
        },
        {
            id: 8,
            title: "Like",
            label: "You have Liked @someone's Incident",
            details: "Baroda Location",
            date: "30 March 2024",
            svg: "heart",
            isIncident: true
        }
    ],
    thisMonth: [
        {
            id: 9,
            title: "Like",
            label: "You liked someones post",
            details: "who wnat's to party",
            date: "2 min ago",
            svg: "heart"
        },
        {
            id: 10,
            title: "Repost",
            label: "you have reposted @someones post",
            details: "Who wins IPL match",
            date: "5 min ago",
            svg: "repeat"
        },
        {
            id: 11,
            title: "Post",
            label: "You have create a post",
            details: "you have created text with #hashtag and @someone",
            date: "3 hr ago",
            svg: "post"
        }
    ],
    pastDays: [
        {
            id: 12,
            title: "poll - Vote Post",
            label: "You have vote from @someone",
            details: "Who won IPl match",
            date: "31 January 2024",
            svg: "check-square"
        },
        {
            id: 13,
            title: "Post",
            label: "you have created Audio post",
            details: "",
            date: "20 January 2024",
            svg: "post"
        },
        {
            id: 14,
            title: "Post",
            label: "you have created Vido post",
            details: "",
            date: "5 January 2024",
            svg: "post"
        },
        {
            id: 15,
            title: "Post",
            label: "You have created incident",
            details: "Rajkot Location",
            date: "31 December 2023",
            svg: "post",
            isIncident: true
        },
        {
            id: 16,
            title: "Like",
            label: "You have Liked @someone's Incident",
            details: "Baroda Location",
            date: "30 Novembr 2023",
            svg: "heart",
            isIncident: true
        }
    ]
};

const Activity = () => {
    const [openModal, setOpenModal] = useState(false);
    return (
        <FeedLayout pageTitle="Activity">
            <div className="notifications-page">
                <div className="d-flex flex-j-between flex-a-center gap-10 w-full text-center mb-30 mt-20">
                    <Link to="/">
                        <SVG svg="chevron-left" size={24} />
                    </Link>
                    <h1 className="fw-700 fs-12em">Activity</h1>

                    <div
                        className="svg-circle big-circle"
                        onClick={() => setOpenModal(true)}
                    >
                        <SVG svg="trash" size={24} />
                    </div>
                </div>
                <div className="card pl-10 pr-10 pt-10 pb-10">
                    <div className="d-flex flex-j-start">
                        <h2 className="fw-500 fs-100 black-text white-text mb-10">
                            Today
                        </h2>
                    </div>

                    {demoActivityGroup.today.map((a) => (
                        <ActivityItem item={a} key={a.id} />
                    ))}

                    <div className="d-flex flex-j-start">
                        <h2 className="fw-500 fs-100 black-text white-text mb-10">
                            This week
                        </h2>
                    </div>
                    {demoActivityGroup.thisWeek.map((a) => (
                        <ActivityItem item={a} key={a.id} />
                    ))}
                    <div className="d-flex flex-j-start">
                        <h2 className="fw-500 fs-100 black-text white-text mb-10">
                            This Month
                        </h2>
                    </div>
                    {demoActivityGroup.thisMonth.map((a) => (
                        <ActivityItem item={a} key={a.id} />
                    ))}
                    <div className="d-flex flex-j-start">
                        <h2 className="fw-500 fs-100 black-text white-text mb-10">
                            Past Days
                        </h2>
                    </div>
                    {demoActivityGroup.pastDays.map((a) => (
                        <ActivityItem item={a} key={a.id} />
                    ))}
                </div>
            </div>
            <ClearActivityModal open={openModal} setOpen={setOpenModal} />
        </FeedLayout>
    );
};

export default Activity;
